import * as _ from 'lodash';
import { Button, TabConfiguration } from '@ispm/dynamic-form/interfaces/TabConfiguration';
import { FLAG_TYPES } from '@ispm/dynamic-form/constants/FlagTypes';
import { Injectable } from '@angular/core';

@Injectable()
export class TabUtility {

  /**
   * Adds a property to the record as identification to check changed records
   * @param records
   * @returns {any}
   */
  fillValueChangeField(records: any) {
    records.forEach(record => {
      if (!record.hasOwnProperty(FLAG_TYPES.DATA_TOGGLE)) {
        record[FLAG_TYPES.DATA_TOGGLE] = false;
      }
    });
    return records;
  }

  /**
   * This method check for the number of tabs that needs to be limited .
   * A particular type of tab is checked for it's limit .
   * @param tabContext contains the tabs in the context of all type
   * @param tabConfig is the configuration of different tab types.
   */

  checkTabsInContext(tabContext, tabConfig, addTabRequest) {
    let tabs = 0;
    if (addTabRequest) {
      tabs = 1;
    }
    tabContext.forEach((tabTypes) => {
      if (tabTypes.filter(tabType => tabType.type == tabConfig.type).length > 0) {
        tabs++;
      }
    });
    return tabs;
  }

  /**
   * Checks if button needs to removed based on the tab limitation
   * @param tabConfig
   */
  deriveButtonsRequired(tabContext, tabConfig: TabConfiguration, buttons: Button[], addTabRequest): Array<Button> {
    if (this.checkTabsInContext(tabContext, tabConfig, addTabRequest) >= tabConfig.tabLimit) {
      const buttonIndex = _.findIndex(buttons, button => button.tabType == tabConfig.type);
      if (buttonIndex != -1) {
        buttons.splice(buttonIndex, 1);
      }
    }
    return buttons;
  }

  filterActiveRecords(allRecords: any, deactivatedRecords: any): { activeRecords: Array<any> , deactivatedRecords: Array<any>} {
    let activeRecords: any;
    deactivatedRecords = [];
    activeRecords = allRecords.filter(obj => {
      if (obj.hasOwnProperty(FLAG_TYPES.STATUS) && obj.status !== 'Y') {
       deactivatedRecords.push(obj);
      }
      return obj.hasOwnProperty(FLAG_TYPES.STATUS) && obj.status == 'Y';
    });
    return { activeRecords, deactivatedRecords};
  }

  deActivateRecords(records: any): Array<any> {
    const deActivatedRecords: any[] = [];
    records.forEach(obj => {
      if (obj.hasOwnProperty(FLAG_TYPES.STATUS)) {
        obj.status = 'N';
        deActivatedRecords.push(obj);
      }
    });
    return deActivatedRecords;
  }

  /**
   * This method fills in the initial data required for the configs associated .
   * @param correlationId
   * @param tabItem
   * @param associator
   * @returns {{}}
   */
  fillInitialData(correlationId, tabItem, associator, groupIds) {
    const CorrelationId: number = 0;
    const typeOfTab: number = 1;
    const subResourceType: number = 2;
    const initialData = { };

    initialData[groupIds[CorrelationId]] = correlationId;
    initialData[groupIds[typeOfTab]] = tabItem.type;
    initialData[groupIds[subResourceType]] = associator.subResourceType;
    initialData[FLAG_TYPES.CREATION_DATE] = JSON.stringify(new Date().getTime());
    initialData[FLAG_TYPES.FORM_ID] = associator.formId;
    initialData[FLAG_TYPES.STATUS] = 'Y';
    return initialData;
  }


  /**
   * The interpolate Query will be refined for the attribute and the attribute if found in data,
   * the data
   * @param interpolateQuery
   * @param data
   */
  interpolateTitle(interpolateQuery, data) {
    let interpolateItem = interpolateQuery.replace('$', '');
    interpolateItem = interpolateItem.replace('{', '');
    interpolateItem = interpolateItem.replace('}', '');
    console.log(interpolateItem);
    data.forEach(record => {
      if (record.hasOwnProperty(interpolateItem)) {
        return record[interpolateItem].display;
      }
    });
  }

  /**
   * This method checks if default tab is required to be loaded .
   * @param tabCorrelator
   * @param tabConfiguration
   * @returns {boolean}
   */
  singleCorrelationExistWithoutDefaultTab(tabCorrelator, tabConfiguration): boolean {
    let isWithoutDefaultTab = false;
    if (tabCorrelator.size == 1) {
     tabCorrelator.forEach((tabTypes) => {
        if ((tabTypes.filter(tab => tab.type == tabConfiguration.type)).length == 0) {
          isWithoutDefaultTab = true;
        }
      });
    }
    return isWithoutDefaultTab;
  }
}
